'use client';

import {StyleProvider} from '@ant-design/cssinjs';
import React, {type ReactNode} from 'react';
import {ConfigProvider} from '@/utils/antd-imports';
import {BreakpointsProvider} from './shared/Utils/BreakpointsProviderClient';
import {BroadcastChannelProvider} from './shared/Utils/BroadcastChannelProviderClient';
import AntdThemeConfig from './styles/antd-theme';

interface ProvidersProps {
  children: ReactNode;
}

export const AuthProviders = ({children}: ProvidersProps) => {
  return (
    <BroadcastChannelProvider>
      <BreakpointsProvider>
        <StyleProvider layer hashPriority="high">
          <ConfigProvider theme={AntdThemeConfig}>{children}</ConfigProvider>
        </StyleProvider>
      </BreakpointsProvider>
    </BroadcastChannelProvider>
  );
};
